import { Button, ErrorState, Skeleton } from '@lia/ui';
import { Navigate, Outlet, useLocation } from 'react-router';
import { ApiError } from '../lib/api.js';
import { useMe } from './session.js';

export function FullPageLoading({ label = 'Cargando sesión' }: { label?: string }) {
  return (
    <div className="grid min-h-dvh place-items-center bg-surface-canvas">
      <Skeleton className="h-8 w-40" label={label} />
    </div>
  );
}

/**
 * Gate for authenticated routes. Redirects to sign-in, MFA verification or MFA enrollment as the session
 * requires. `mfaStep` routes (verification/enrollment) render before MFA is satisfied.
 * The server still authorizes every request.
 */
export function RequireSession({ mfaStep = false }: { mfaStep?: boolean }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <FullPageLoading />;
  if (me.isError) {
    if (me.error instanceof ApiError && me.error.kind === 'unauthorized') {
      const here = location.pathname + location.search;
      const next = location.pathname === '/' ? '' : `?siguiente=${encodeURIComponent(here)}`;
      return <Navigate to={`/ingresar${next}`} replace />;
    }
    return (
      <div className="grid min-h-dvh place-items-center bg-surface-canvas p-4">
        <ErrorState description={me.error.message} action={<Button onClick={() => void me.refetch()}>Reintentar</Button>} />
      </div>
    );
  }
  const { user, session } = me.data;
  if (!mfaStep) {
    const next = encodeURIComponent(location.pathname + location.search);
    if (user.mfaEnabled && !session.mfaVerified) return <Navigate to={`/verificacion?siguiente=${next}`} replace />;
    if (session.mfaEnrollmentRequired && !user.mfaEnabled) return <Navigate to={`/seguridad?siguiente=${next}`} replace />;
  }
  return <Outlet />;
}
